import React from "react";
import { SEO, MarkdownContent, DynamicForm } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class JoinTheWaitlistPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      haigkcakpcekfakijgchhbmnfdgnboichaig,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.lusciousandco.com/join-the-waitlist/"}
        />
        <Grid
          className={"custom-page-join-our-waitlist custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"leleciikgohieidd"}
            style={{ padding: 16 }}
            columns={2}
          >
            <Grid.Column
              className={"bljaddflfnekegfo"}
              style={{ padding: "100px", background: "#ECDFD3" }}
              textAlign={"center"}
              verticalAlign={"top"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "d7e0b359-5f76-48ab-997b-b200ef8fd98b",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"faefdbnbgpjpefng"}
              style={{ padding: 16 }}
              textAlign={"left"}
              verticalAlign={"top"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={2553}
                  businessInfoId={7701}
                  websiteId={9168}
                  locationId={2715}
                  componentConfigurationId={166912}
                  header={haigkcakpcekfakijgchhbmnfdgnboichaig.data.header}
                  fields={
                    haigkcakpcekfakijgchhbmnfdgnboichaig.data.dynamicFormFields
                  }
                  consentSettings={
                    haigkcakpcekfakijgchhbmnfdgnboichaig.data.consentSettings
                  }
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 34929 }) {
      title
      seoTitle
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
    haigkcakpcekfakijgchhbmnfdgnboichaig: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "6101de67-80b5-4f27-991f-5f1c6bf1dc1c" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          style {
            color
            marginTop
            marginBottom
          }
          content
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
        consentSettings {
          show
          required
        }
      }
    }
  }
`;
